import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/**
 * Application entry point.
 * Mounts the React app to the DOM root element.
 */
if (window.location.hostname === 'www.polarace.com') {
  const canonicalUrl = `https://polarace.com${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(canonicalUrl);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
